import app from './application';
import {
  REJECT_TIMEOUT,
  NAMESPACE,
  REQUIREJS_URL
} from './constants';

const {$, RSVP} = window;

const Voonto = Object.preventExtensions({
  getInstance() {
    return app;
  },

  ready: (() => {
    var allP;

    allP = [];
    allP.push(_deployRequireJS());
    allP.push(_domReadyP());
    allP.push(window.__VOONTO__.createGlobal(NAMESPACE));

    return RSVP.all(allP)
      .then(() => app.require = window.requirejs)
      .then(() => app.define = window.define)
      .then(() => window.define = undefined)
      .then(() => app)
    ;
  })()
});

export default Voonto;

/* Private */

function _deployRequireJS() {
  return new RSVP.Promise((resolve, reject) => {
    var script;

    script = document.createElement('script');
    script.src     = REQUIREJS_URL;
    script.async   = true;
    script.onload  = () => resolve(window.requirejs);
    script.onerror = reject;

    document.body.appendChild(script);
  });
}

function _domReadyP() {
  return new RSVP.Promise((resolve, reject) => {
    $(document).ready(resolve);
    setTimeout(reject, REJECT_TIMEOUT); // FIXME: cancel timer when resolved
  });
}



// WEBPACK FOOTER //
// ./src/voonto.js